export default __webpack_public_path__ + "static/media/icon-scene-panoramic.fe2267ff.svg";